
import React, {useEffect, useState}from "react";
import { useParams } from "react-router-dom";
import { Row, Col, Skeleton } from "antd"
import { getInfoQrGafete } from "../../../api/gafete";
import imgNoAcreditado from "../../../assets/img/Portal/icono_verificador.svg"

const Gafete = () =>{
    const {folio} = useParams();
    const [datos, setDatos] = useState({})
    const [loader, setLoader] = useState(true)
    const [imagen, setImagen] = useState({})
    useEffect (()=>{
        const urlParams = new URLSearchParams(window.location.search); //Aqui se obtienen los parametros de la URL
        getInfoQrGafete(urlParams.get('obs')).then((res=>{
            setLoader(res.data.loading)
            setDatos(res.data.ciudadano)
            setImagen({
                imageUrl:
                "data:image/png;base64," +
                res.data.ciudadano.imagen,
            })
        }))
    },[folio]);

    return(
    <>
        <div>
            <Skeleton avatar shape="square" active loading={loader} paragraph={{ rows: 15 }}/>
        </div>
        {!loader &&
            <div>
                <h2 style={{textAlign:"center", marginTop: 50}}> 
                {datos && datos.acreditado
                ? 'Información de la/el ciudadana/o acreditada/o'
                : 'La/el ciudadana/o no se encuentra acreditada/o'
                }
                </h2>
                <Row>
                    <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                        <Row>
                            <Col span={24} style={{textAlign:"center", margin: "20px"}}>
                                <img 
                                    src={datos && datos.acreditado ? imagen.imageUrl : imgNoAcreditado}
                                    alt="foto"
                                    style={{ width: "50%" }}
                                />
                            </Col>
                        </Row>
                    </Col>
                    {!loader && datos && datos.acreditado &&
                    <Col xs={24} sm={24} md={24} lg={16} xl={16}>
                        <Row justify="start">
                            <Col>
                                <p><b>Nombre del solicitante:</b><br/>
                                {datos.nombre + ' ' + datos.apellidoP + ' ' + datos.apellidoM}</p>
                            </Col>
                            <Col>
                                <p><b>Fecha de aprobación de la acreditación:</b><br/>
                                {datos.fechaAcreditacion}</p>
                            </Col>
                            <Col>
                                <p><b>Folio:</b><br/>
                                {datos.folio}</p>
                            </Col>
                        </Row>
                    </Col>
                    }
                </Row>
            </div>
        }
    </>
    )
}
export default Gafete;